var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFalseIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3104 6.65518C13.3104 10.3307 10.3307 13.3104 6.65518 13.3104C2.97963 13.3104 0 10.3307 0 6.65518C0 2.97963 2.97963 0 6.65518 0C10.3307 0 13.3104 2.97963 13.3104 6.65518Z",
    fill: "#A6A7A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFalseIcn);
export default __webpack_public_path__ + "static/media/falseIcn.9dd9789043d528b77e958393136341da.svg";
export { ForwardRef as ReactComponent };